import { S } from '../styles.js';
import { motion, AnimatePresence } from 'framer-motion';

// Stepper Component
export function Stepper({ currentStep, onStepClick, completedSteps }) {
  const steps = [
    'Company Details',
    'Overview',
    'Experience',
    'Benefits',
    'Referees',
    'Declaration'
  ];

  return (
    <div style={S.stepper}>
      {steps.map((label, index) => (
        <div
          key={index}
          style={S.pill(currentStep === index, completedSteps.includes(index))}
          onClick={() => onStepClick(index)}
        >
          {completedSteps.includes(index) ? '✓' : index + 1}. {label}
        </div>

      ))}
    </div>
  );
}